import axios from 'axios'
import { message as Message } from 'ant-design-vue'
import store from '@/store/index'
import { computed } from 'vue'
const ucUserId = computed(() => store.getters?.userInfo?.ucUserId)
const URL = process.env.VUE_APP_AI
/**
 *
 * @param {*} param
 * params 接口请求参数
 * onPatch 有新的内容更新时执行
 * onCreated 发出请求收到第一个回包后执行
 * onDone 传输结束时执行
 * onFail 失败的回调方法
 */
export async function readStreamData(param) {
  const { params, onDone, onFail, onCreated, onPatch } = param
  const { query, method = 'post' } = params

  query.p = {
    ...query.p,
    uc_user_id: ucUserId.value,
    uc_user_role: 4
  }
  let question_id = null
  let onCreatedCb = onCreated
  try {
    const controller = new AbortController()
    const requestInstance = new Request(URL, {
      method,
      signal: controller.signal,
      responseType: 'stream',
      headers: {
        // token: getToken(),
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(query)
    })
    const response = await fetch(requestInstance)

    // ok字段判断是否成功获取到数据流
    if (!response.ok) {
      onFail && onFail()
    }
    // 用来获取一个可读的流的读取器（Reader）以流的方式处理响应体数据
    const reader = response.body.getReader()
    // 将流中的字节数据解码为文本字符串
    const textDecoder = new TextDecoder()
    let result = true
    while (result) {
      if (onCreatedCb) {
        onCreatedCb(controller)
        onCreatedCb = undefined
      }
      const { done, value } = await reader.read()
      if (done) {
        onDone && onDone({ question_id })
        result = false
        break
      }
      textDecoder
        .decode(value)
        .split('\n\n')
        .forEach(val => {
          if (!val) return
          try {
            const data = val.substr(5, val.length)
            const json = JSON.parse(data)
            if (json.success) {
              const text = json.data.content || json.data.goal_prompt || ''
              question_id = json.data.question_id || null
              onPatch && onPatch(text)
            } else {
              onPatch && onPatch('')
            }
          } catch (err) {
            //
          }
        })
    }
  } catch (err) {
    onFail && onFail()
  }
}
export function requstMethod(params) {
  const { query, method = 'get' } = params
  const queryKey = method === 'get' ? 'params' : 'data'

  query.p = {
    ...query.p,
    uc_user_id: ucUserId.value,
    uc_user_role: 4
  }
  const requestParam = {
    url: URL,
    method,
    [queryKey]: query,
    headers: {
      // token: getToken()
    }
  }
  return new Promise((resolve, reject) => {
    axios(requestParam)
      .then(res => {
        const { data = {} } = res
        const { code, msg } = data
        if (code === 0) {
          resolve(res?.data || {})
        } else {
          Message.error(msg)
          reject('')
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
